/**
 * Regular expression for matching file names, with or without extension.
 */
export const filenameRegex = () => /([^\\\/]+)$/;

export const emailRegex = () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
